import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";
import { CaseState } from "./case-state";
import { Company } from "../../companies/_types/company";
import { CaseType } from "../../cases-types/_types/case-type";
import { Contract } from "../../companies/_types/contract";
import { ClientPolicy } from "../../clients/_types/client-policy";
import { User } from "../../users/_types/user";
import { Address } from "../../common/_types/address";
import { ServiceType } from "../../services-types/_types/services-types";
import { CaseTreatment } from "./case-treatment";
import { CaseServiceType } from "./case-service-type";
import { CaseExpert } from "./case-expert";
import { Transaction } from "sip.js/lib/core";
import { CaseNotificationNumber } from "./case-notification-number";
import { CaseService } from "./case-service";
import { CaseMode } from "./case-mode";
import { CaseMediator } from "./case-mediator";

export class Case extends Resource {
    public override type = 'cases';

    @prop()
    public reference!: string;

    @prop()
    public caseNumber!: string;

    @prop()
    public caseNumberSecondary?: string;

    @prop()
    @required()
    public caseDate: Date = new Date();

    @prop()
    @required()
    public lastActionDate: Date = new Date();

    @prop()
    @required()
    public description!: string;

    @prop()
    public notes!: string;

    @prop()
    @required()
    public caseTypeId!: string;

    @propObject(CaseType)
    public caseType!: CaseType;

    @prop()
    @required()
    public companyId!: string;

    @propObject(Company)
    public company!: Company;

    @prop()    
    @required()
    public contractId!: string;

    @propObject(Contract)
    public contract!: Contract;

    @prop()
    @required()
    public clientId!: string;

    @propObject(Client)
    public client!: Client | null;

    @prop()    
    public clientPolicyId!: string;

    @propObject(ClientPolicy)
    public clientPolicy!: ClientPolicy | null;

    @prop()
    public processorId!: string;

    @propObject(User)
    public processor!: User;

    @prop()
    public caseStateId!: string;

    @propObject(CaseState)
    public caseState!: CaseState;

    @prop()
    public caseStateMetadata?: string;

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address!: Address;

    @prop()
    public revisionDate!:  Date;

    public displayName!: string;

    @prop()
    public isUrgent: boolean = false;

    @prop()
    public isVIP: boolean = false;

    @prop()
    public isPrecite: boolean = false;

    @prop()
    public isRecapture: boolean = false;

    @prop()
    public recaptureDate?: Date;

    @prop()
    public notificationNumber!: string;
    @prop()
    public caseNotificationNumbers!: CaseNotificationNumber[];

    @prop()
    public capabilityDescription!: string;

    @prop()
    public closeNotes!: string;

    @prop()
    public profitReviewAcknowledged: boolean = false;

    @prop()
    public companyWorkInProgress: number = 0;

    
    @prop()
    @required()
    public caseTreatmentId!:string;

    
    @propObject(CaseTreatment)
    public caseTreatment!: CaseTreatment;

    @prop()
    public declaration!: string;

    @prop()
    public caseServiceTypes!: CaseServiceType[];

    @prop()
    public firstServiceTypeName!: string;

    @prop()
    public caseExperts!: CaseExpert[];

    @prop()
    public transactions!: Transaction[];

    @prop()
    public budgetOrder!: number;

    @prop()
    public expertStatus?: string;

    @prop()
    public invoicesStatus?: string;

    @prop()
    public budgetsStatus?: string;


    @prop()
    public lastConnectedUserId?: string;

    @prop()
    public lastConnectedUserDate?: Date;

    public expertTooltip?: string;
    
    public caseServices!: CaseService[];

    @prop()
    public pendingCapabilityId?: string;

    @prop()
    public caseModeId!: string;
    
    @propObject(CaseMode)
    public caseMode!: CaseMode;


    @prop()
    public caseMediators!: CaseMediator[];

}